import React from 'react';

export const Experience = ({experiences}) => {
    return (
        <ul>
            {experiences.map((exp, index) => (
                <li key={index}>
                    <span className="date">{exp.date}</span><br/>
                    <span className="title">{exp.title}</span><br/>
                    <span className="affiliation">
                        <a href={exp.affiliation.url} target="_blank" rel="noopener noreferrer">
                            {exp.affiliation.name}
                        </a>
                    </span><br />
                    <span className="description">{exp.description}</span>
                </li>
            ))}
        </ul>
    );
};